module.exports = __webpack_public_path__ + "img/cxTrends-16.9d3a52e1.png";